import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { ApiProgress } from "../../Utilities/ApiProgress";
import { useProductSettingsContext } from "./context/ProductSettingsContext";
import { ProductSettingsDistributorGrid } from "./components/ProductSettingsDistributorGrid";
import InfoDialog from './dialogs/InfoDialog';
import ErrorDialog from './dialogs/ErrorDialog';
import FileUpload from "../../Components/FileUpload";
import { PausedIndicator } from "../../Components/PausedIndicator";

const enablePauseIndicator = process.env.REACT_APP_ENABLE_PAUSE_INDICATOR === 'true';

const getProductSettingsUploadTemplateCsv = () =>
    process.env.REACT_APP_ENABLE_IN_MARKET_DATE === 'true'
        ? 'distributor,sku,offeringStatus,fulfillmentMethod,directDistributor,palletQuantity,palletDivisor,unitWeight,inMarketDate\n'
        : 'distributor,sku,offeringStatus,fulfillmentMethod,directDistributor,palletQuantity,palletDivisor,unitWeight\n';

const ProductSettings = () => {
    const {
        dataLoaded,
        productDefaults,
        unfilteredProductSettingsDistributorTable,
        inMarketDateError,
        clearInMarketDateError,
    } = useProductSettingsContext();

    const anyPaused = enablePauseIndicator && (unfilteredProductSettingsDistributorTable?.some(row => row?.paused) ?? false);

    return (dataLoaded ? <Paper elevation={1} sx={{ padding: 2, margin: 2 }}>
        <Stack direction='column' spacing={1}>
            <Grid container>
                <Grid item xs={10}>
                    <Stack direction='row' alignItems='center' spacing={1}>
                        {anyPaused ? <PausedIndicator size={28} /> : null}
                        <Typography
                            variant='h4'>{productDefaults.brandFamily} {productDefaults.description} ({productDefaults.sku})</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={2} direction="row" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FileUpload
                        uploadUrl="api/products/productSettings"
                        buttonText="Upload Settings"
                        accept=".csv"
                        InfoDialogComponent={InfoDialog}
                        ErrorDialogComponent={ErrorDialog}
                        templateDownloadFileName="ProductSettingsUploadTemplate.csv"
                        templateDownloadTooltip="Download template"
                        getTemplateDownloadContent={getProductSettingsUploadTemplateCsv}
                    />
                </Grid>
            </Grid>
            <div style={{ width: "100%", height: "70vh" }}>
                <ProductSettingsDistributorGrid />
            </div>
        </Stack>
        <Dialog open={!!inMarketDateError} onClose={clearInMarketDateError}>
            <DialogTitle>Invalid In-Market Date</DialogTitle>
            <DialogContent>
                <Typography>{inMarketDateError}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={clearInMarketDateError} autoFocus>OK</Button>
            </DialogActions>
        </Dialog>
    </Paper> : <ApiProgress />)
}

export default ProductSettings;